var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c("div", { staticClass: "main-content" }, [
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "config-module": _vm.configModule,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefList,
              "export-file-name": _vm.priceUtil.getFileName(_vm.fileName),
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }